import {listener, onReady} from "../../../../../modules/vegas/js/util";
import YandexMetrika from "./yandexMetrika";

listener('click', '[data-yagoal]', (el, e) => {
	String(el.dataset.yagoal).split(',').forEach(goal => {
		new YandexMetrika().goal(goal);
	});
});

listener('submit', '[data-yagoal-form]', (el, e) => {
	String(el.dataset.yagoalForm).split(',').forEach(goal => {
		new YandexMetrika().goal(goal);
	});
});

function ready() {
	document.querySelectorAll('[data-yagoal-static]').forEach((el) => {
		new YandexMetrika().goal(el.dataset.yagoalStatic);
	});
}

onReady(ready);
typeof onTurboRender !== 'undefined' && onTurboRender(onReady);
